import { FormattedMessage } from "react-intl";
import type { StepProps } from "../../hooks/usePixiWizardState";
import { EligibilityBanner } from "./EligibilityBanner";
import { ScreenCountStepper } from "./ScreenCountStepper";
import {
  ScreenChoiceCard,
  ScreenChoiceCardLayout,
  StepHelper,
  StepLayout,
  StepTitle,
  TitleBlock,
} from "./styles";

export const NumberOfScreensStep = ({ state, updateState }: StepProps) => {
  const setScreenCount = (screenCount: number) => updateState({ screenCount });

  return (
    <StepLayout data-testid="number-of-screens-step">
      <ScreenChoiceCard>
        <ScreenChoiceCardLayout>
          <TitleBlock>
            <StepTitle data-testid="number-of-screens-title">
              <FormattedMessage
                id="pixi_wizard.screens.title"
                defaultMessage="How many screens do you want to set up?"
              />
            </StepTitle>
            <StepHelper data-testid="number-of-screens-helper">
              <FormattedMessage
                id="pixi_wizard.screens.helper"
                defaultMessage="{count, plural, one {Get 1 free hardware for every screen or enjoy discounts at checkout.} other {Get # free hardware for every screen or enjoy discounts at checkout.}}"
                values={{ count: state.screenCount }}
              />
            </StepHelper>
          </TitleBlock>
          <ScreenCountStepper
            screenCount={state.screenCount}
            onDecrement={() => setScreenCount(state.screenCount - 1)}
            onIncrement={() => setScreenCount(state.screenCount + 1)}
            canDecrement={state.screenCount > 1}
          />
        </ScreenChoiceCardLayout>
      </ScreenChoiceCard>
      <EligibilityBanner count={state.screenCount} />
    </StepLayout>
  );
};
